import "./index.less";
import { formatPrice } from "../../utils";
import { goToPageV2 } from "@/utils/common";

const CardGoodsRow = ({
  userCardList,
  type = "card",
  click,
}: {
  userCardList: any[];
  type?: "card" | "coupon";
  click?: () => void;
}) => {
  const gotoBuyMorePage = () => {
    if (click) click?.();
    // 跳转会员购买页，待补充
    goToPageV2({
      hash: "/vip-goods",
      pathname: window.location.pathname,
    });
  };
  // 0-生效中 1-无效
  return (
    <div
      className="vip-card-goods-row"
      onScroll={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {userCardList?.map((item, index) => {
        return type === "card" ? (
          <div className="card" key={index}>
            <div>
              <div className="card-title">充电VIP储值卡</div>
              <div className="card-describe">抵扣电费·服务费</div>
            </div>
            <div>
              <div className="card-limit">
                面值<span className="card-Amt">{item.chargeCardTotalAmt}</span>
              </div>
              <div className="card-surplus">
                余额：{item.chargeCardValidAmt}
              </div>
            </div>
          </div>
        ) : (
          <div className="coupon" key={index}>
            <div>
              <div className="coupon-title">充电VIP券</div>
              <div className="coupon-describe">
                {item?.thresholdPrice
                  ? `服务费满${formatPrice(item?.thresholdPrice, 0)}元`
                  : "无门槛"}
              </div>
            </div>
            <div className="coupon-info">
              <div className="coupon-limit">
                {item?.couponType === 1 && (
                  <>
                    <span className="unit">¥ </span>
                    <span className="amt">
                      {formatPrice(item?.couponFee, 0)}
                    </span>
                  </>
                )}
                {item?.couponType === 2 && (
                  <>
                    <span className="amt">{item?.couponFee}</span>
                    <span className="unit"> 折</span>
                  </>
                )}
              </div>
              <div className="coupon-num">{item?.couponNum}张</div>
            </div>
            <div className="coupon-status">{item.couponStatusName}</div>
          </div>
        );
      })}
      <div className="buy-btn-plain" onClick={() => gotoBuyMorePage()}>
        购买更多
      </div>
    </div>
  );
};

export default CardGoodsRow;
